import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import IconAsset from '../../../../components/icon/IconAsset';
import { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { LITE_TRADE_POSITION_SIDE } from '../../liteTradeConstants';
import amountFormat from '../../../../utils/amountFormat';
import classNames from 'classnames';
import Animation from '../../../Animation/Animation';
import { useTimer } from '../../../../hooks/useTimer';
import {
    LiteTradeNotificationPositionClosedAmountContainerStyled,
    LiteTradeNotificationPositionClosedButtonStyled,
} from './styled/LiteTradeNotificationPositionClosedStyled';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router';
import {
    MOBILE_SLIDER_PAGES_IDS,
} from '../../../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants';
import { useDispatch } from 'react-redux';
import BinIcon from '../../../../components/icon/Icon';
import { toast } from 'react-toastify';
import { locationSlice } from '../../../Location/locationReducer';
import { LOCATION_NAMES } from '../../../Location/locationConstants';

function LiteTradeNotificationPositionClosed(props) {
    const { assetInstance, order, lotsAmount, margin, pl, price } = props;
    const { getLangPath } = useLangContext();
    const assetDescription = assetInstance.asset.info.description;
    const isBuy = _.toUpper(order.side) === LITE_TRADE_POSITION_SIDE.BUY;
    const [animationEnabled, setAnimationEnabled] = useState(false);
    const { startTimer: enableAnimationByTimer } = useTimer(() => setAnimationEnabled(true));
    const dispatch = useDispatch();
    const openMobileSliderPage = useCallback(() => {
        toast.dismiss();
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.ASSET,
            searchParams: { symbol: assetInstance.symbol },
        }));
    }, [assetInstance.symbol, dispatch]);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const slider = params.get('s');
    const isAssetSliderOpenOn = slider === MOBILE_SLIDER_PAGES_IDS.ASSET;

    useEffect(() => {
        if (pl <= 0) {
            return;
        }
        enableAnimationByTimer(600);
    }, [pl, enableAnimationByTimer]);

    return <div className='d-flex flex-column align-items-center py-3'>
        <div className='f28 mt-3'>
            <IconAsset symbol={assetInstance.symbol}/>
        </div>
        <h3 className='text-primary f20 fw600 mt-2 mb-0 text-center'>
            {getLangPath(`lite_version.notifications.${isBuy ? 'bought_asset' : 'sold_asset'}`, {
                asset: assetDescription,
            })}
        </h3>
        <p className='text-secondary f16 fw300 mt-2'>{assetInstance.symbol}</p>
        <LiteTradeNotificationPositionClosedAmountContainerStyled>
            <span className={classNames('d-flex f28 fw600', {
                positive: pl > 0,
            })}>
                {pl !== null && amountFormat(pl, 2, '$', false, { withSign: true })}
            </span>
            {animationEnabled && <Animation name={'Confetti'} loop={false} className={'animation'}/>}
        </LiteTradeNotificationPositionClosedAmountContainerStyled>
        <div
            className='f14 mt-2 text-secondary'
            dangerouslySetInnerHTML={{
                __html: getLangPath('lite_version.notifications.basic_info', {
                    lots_amount: amountFormat(Math.abs(lotsAmount) || 0, 2),
                    margin: `${amountFormat(Math.abs(margin) || 0, 2)}`,
                    order_type: getLangPath(`lite_version.order.types.${_.toLower(order.type)}.type`),
                    price: assetInstance.roundAmount(price || 0),
                    side: '',
                }),
            }}
        />
        {!isAssetSliderOpenOn ? (
            <LiteTradeNotificationPositionClosedButtonStyled>
                <Button
                    className='w-100 fw400'
                    style={{ color: 'var(--color-label-primary)' }}
                    variant={'tertiary'}
                    size={'sm'}
                    onClick={openMobileSliderPage}
                >
                    {getLangPath('lite_version.notifications.button.repeat') + ' '}
                    <BinIcon
                        name={'IcRefresh'}
                        size={16}
                        style={{
                            marginRight: 5,
                            marginTop: -3,
                            fill: 'currentcolor',
                        }}
                    />
                </Button>
            </LiteTradeNotificationPositionClosedButtonStyled>
        ) : null}
    </div>;
}

export default LiteTradeNotificationPositionClosed;
